import styled from 'styled-components';

import { ActionButton } from 'src/commons/components/Button';
import SubHeading from 'src/commons/components/SubHeading';
import {
  TABLET_BREAKPOINT,
  MOBILE_BREAKPOINT,
  colors,
} from 'src/commons/constants';

export const Body = styled.div`
  margin: 1.625rem 0 0;
  width: 100%;
  display: flex;
  flex-flow: row-reverse nowrap;
  flex: 1;
  justify-content: center;
  align-items: flex-start;
  @media (max-width: ${TABLET_BREAKPOINT}) {
    flex-flow: column;
    align-items: center;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-top: 0.5rem;
  }
`;

export const Main = styled.main`
  &:focus-visible {
    outline: none;
  }
`;

export const ApplyHeadingWrapper = styled.div`
  margin: 4rem 0 2rem;
`;

export const FormSectionHeading = styled(SubHeading)`
  width: 100%;
  margin: 0 0 0.3125rem;
  text-align: left;
  color: ${colors.TEXT_PRIMARY};
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin: 0 0 0.5rem;
  }
`;

export const IncomeSectionHeading = styled(FormSectionHeading)`
  margin-bottom: 0;
  line-height: 1.5rem;
`;

// Form containing all text inputs and continue button
export const Form = styled.form`
  width: 25rem;
  display: flex;
  flex-flow: column nowrap;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
  }
`;

export const FormSection = styled.div`
  width: 100%;
  margin: 0.5rem 0;
`;

// Stretches content across width of parent TextInputsContainer
export const FullWidthRow = styled.div`
  margin-bottom: 0.75rem;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
`;

export const HalfWidthInput = styled.div`
  flex: 1;
  margin-right: 0.75rem;
`;
HalfWidthInput.displayName = 'HalfWidthInput';

// Contains TextInput so multiple inputs can be positioned within a FullWidthRow
export const HalfWidthInputsContainer = styled.div`
  display: flex;
  flex: 1;
  flex-flow: row nowrap;
  ${HalfWidthInput}:last-child {
    margin-right: 0;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    flex-direction: column;
    ${HalfWidthInput}:first-child {
      margin-right: 0;
      margin-bottom: 0.75rem;
    }
  }
`;

export const TotalIncomeRow = styled.div`
  width: 100%;
  margin-top: 0.25rem;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
`;

export const TotalIncomeLabel = styled.div`
  color: ${colors.TEXT_PRIMARY};
`;

export const TotalIncomeValue = styled.div`
  font-size: 1.125rem;
  text-align: right;
  color: ${colors.TEXT_ACTION};
  font-weight: 500;
`;

export const SchumerSection = styled.div`
  width: 100%;
  margin: 1rem 0 1.875rem;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin: 1rem 0 2.125rem;
  }
`;

export const SchumerNotice = styled.p`
  margin: 2.8125rem 0 0.75rem;
  font-weight: 500;
  font-size: 0.9375rem;
  line-height: 1.5rem;
  text-align: left;
  color: ${colors.TEXT_PRIMARY};
`;

// Left-justified, dark-gray text to the right of the checkbox, e.g. agreement copy
export const CheckBoxText = styled.p`
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  text-align: left;
  color: ${colors.TEXT_PRIMARY};
`;

export const SubmitText = styled(SubHeading)`
  margin: 0 0 7.5rem;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 0.875rem;
    line-height: 1;
  }
`;

// Continue Button along bottom of card
export const SubmitButton = styled(ActionButton)`
  margin: 0 0 0.625rem;
`;

export const AboutYouWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
`;
